import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProfessorApiService } from 'src/app/shared/services/professor-api.service';
import { DataBaseRequest, DataBaseResponse } from '../models/login.model';

@Injectable({
  providedIn: 'root',
})
export class DataBaseSearchService extends ProfessorApiService {
  loading = false;

  constructor() {
    super(inject(HttpClient));
  }

  async dataBaseListRequest(
    payload: DataBaseRequest,
  ): Promise<DataBaseResponse[]> {
    this.loading = true;
    const response: DataBaseResponse[] = await this.makeHttpRequest({
      url: `login?tipo=BANCO&CPF=${payload.cpf}`,
      method: `GET`,
      body: payload,
    }).finally(() => (this.loading = true));

    return response;
  }
}
